import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Notfall", -1),
    _createElementVNode("path", {
      d: "M111.15 80.84a4 4 0 0 1-1.17-2.83l.03-48c0-1.1-.9-2-2-2L84 27.99c-.72 0-1.2.37-1.42.58-.22.22-.59.69-.59 1.42v48.02c0 2.21-1.79 4-4 4H30c-.72 0-1.2.37-1.42.59s-.59.69-.58 1.42l.02 24.01c0 .72.37 1.19.58 1.41s.69.58 1.41.58l47.98-.02c1.06 0 2.08.42 2.83 1.17s1.17 1.77 1.17 2.83v48c0 1.1.9 2 2 2h23.98c1.1 0 2-.9 2-2v-48c0-2.21 1.79-4 4-4h48.02c1.1 0 2-.9 2-2V84.02c0-1.1-.9-2-2-2h-48.02c-1.06 0-2.08-.42-2.83-1.17Z",
      style: {"fill":"none"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M108.01 20.02 84 20c-2.67 0-5.18 1.04-7.07 2.93A9.93 9.93 0 0 0 74 30v44.02H30c-2.67 0-5.19 1.04-7.08 2.93a9.96 9.96 0 0 0-2.93 7.08l.02 24c0 2.67 1.04 5.18 2.93 7.07a9.94 9.94 0 0 0 7.05 2.92h.02l43.97-.02v44c0 5.52 4.49 10 10 10h23.98c5.51 0 10-4.49 10-10v-44h44.02c5.51 0 10-4.49 10-10V84.02c0-5.52-4.49-10-10-10h-44.02l.03-44c0-5.51-4.48-10-9.99-10Zm53.99 62c1.1 0 2 .9 2 2V108c0 1.1-.9 2-2 2h-48.02c-2.21 0-4 1.79-4 4v48c0 1.1-.9 2-2 2H84c-1.1 0-2-.9-2-2v-48c0-1.06-.42-2.08-1.17-2.83A4 4 0 0 0 78 110l-47.98.02a1.98 1.98 0 0 1-1.99-1.99l-.02-24.01c0-.72.37-1.2.58-1.42.22-.22.7-.59 1.42-.59H78c2.21 0 4-1.79 4-4V30c0-.72.37-1.2.59-1.42s.69-.58 1.42-.58l24.01.02c1.1 0 2 .9 2 2l-.03 48c0 1.06.42 2.08 1.17 2.83s1.77 1.17 2.83 1.17h48.02Z",
      style: {"fill":"#2d2d2d"}
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "aid"}) } }